var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 71,
    viewBox: "0 0 48 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24172 51.794C6.17672 50.7281 8.6094 51.4327 9.67527 53.3677C12.8714 59.1701 18.6612 62.9034 25.0288 62.9034C31.3976 62.9034 37.1884 59.1687 40.3843 53.3809C41.4521 51.447 43.8855 50.7449 45.8194 51.8127C47.7533 52.8806 48.4554 55.314 47.3876 57.2479C42.9527 65.2797 34.6438 70.9034 25.0288 70.9034C15.4125 70.9034 7.10262 65.2782 2.66801 57.2275C1.60215 55.2925 2.30672 52.8599 4.24172 51.794Z",
    fill: "#FFB204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.28C37.2548 48.28 48 37.4722 48 24.14C48 10.8078 37.2548 0 24 0C10.7452 0 0 10.8078 0 24.14C0 37.4722 10.7452 48.28 24 48.28Z",
    fill: "#6358EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 44V26C48 23.7909 46.2091 22 44 22C41.7909 22 40 23.7909 40 26V44C40 46.2091 41.7909 48 44 48C46.2091 48 48 46.2091 48 44Z",
    fill: "#6358EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e6b6cff905b7b1786d157e033018942.svg";
export { ForwardRef as ReactComponent };